export default "__VITE_ASSET__D9I4HWGr__"